import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["styles"];

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React from "react";
export default (function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === void 0 ? {} : _ref$styles,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.00505 3h4.00405c2.7638 0 5.0051 2.239 5.0051 5s-2.2413 5-5.0051 5H9.00708v4l-5.00506-5h.02703C2.64065 10.612 2 9.643 2 8c0-2.761 2.24126-5 5.00505-5zm7.00705 5c0-1.654-1.3473-3-3.003-3H7.00506C5.34938 5 4.00202 6.346 4.00202 8c0 .858.20821 1.352 1.44346 2.586l1.55958 1.558V11h4.00404c1.6557 0 3.003-1.346 3.003-3z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6967 10.0908c.1972-.629.3043-1.296.3143-1.987 2.2773.469 3.989 2.483 3.989 4.896 0 1.745-.8959 2.816-2.2533 4.172l-4.7338 4.728v-3.9h-3.003c-.3423 0-.6777-.035-1.001-.101v-2.083c.3153.112.6487.184 1.001.184h5.0051v1.072l1.3163-1.315c1.3243-1.323 1.6667-1.889 1.6667-2.757 0-1.412-.985-2.591-2.3013-2.909z",
    fill: "currentColor"
  }));
});